// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/collection/collection-search/collection-search.component.scss
// module id = 143
// module chunks = 0